module.exports = __webpack_public_path__ + "img/Table-publication.67ca9d84.svg";